import { BuilderComponentGroup } from '../types'

export const ComplexLayoutDesignBlocks: BuilderComponentGroup = {
  id: 'complex-layouts',
  title: 'Complex Layouts',
  components: [
    {
      compId: 'complex-100-50-50',
      title: '100, 50/50',
      icon: 'Columns1005050',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'complex-100-33-33-33',
      title: '100,33/33/33',
      icon: 'Columns100333333',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'complex-100-60-40',
      title: '100, 60/40',
      icon: 'Columns1006040',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'complex-100-40-60',
      title: '100, 40/60',
      icon: 'Columns1004060',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'complex-100-25-75',
      title: '100, 25/75',
      icon: 'Columns1002575',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'complex-100-75-25',
      title: '100, 75/25',
      icon: 'Columns1007525',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
